import React, { PropsWithChildren } from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { AmountProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const Amount: React.FC<PropsWithChildren<AmountProps>> = ({ displayType, children }) => {
  return (
    <span>
      {displayType === StyleEnums.DisplayType.Warning ? (
        <Icon icon={IconDefinitionConstants.WExclamation} className={cssExports.warningIcon} />
      ) : (
        <></>
      )}
      {children}
    </span>
  );
};

export default Amount;
